$(function() {
    var nav_pos = $(".page-nav").offset().top;
var nav_height = $(".page-nav").outerHeight();
$(window).scroll(function () {
    if ($(this).scrollTop() > nav_pos) {
        $("body").css("padding-top", nav_height);
        $(".page-nav").addClass("is-fixed");
    } else {
        $("body").css("padding-top", 0);
        $(".page-nav").removeClass("is-fixed");
    }
});
});


/*カルーセル*/
$(function () {
	var swiper = new Swiper('.swiper-container-main', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		loop: true,
		observer: true,
		observeParents: true,
    effect: 'fade', 
    speed: 2500,
		  /*autoplay: {
        delay: 800,*/
        /*disableOnInteraction: false,*/ // 矢印をクリックしても自動再生を止めない
		  /*},*/
    pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
    /*simulateTouch: false,*//*クリックでスワイプしない*/
		/*loopedSlides: 3,*/
		/*centeredSlides : true,*/
		slideToClickedSlide: true,
		spaceBetween: 20,
		/*slidesPerGroup: 2,*/
    slidesPerView: 1,
		breakpoints: {
			// 768px以上の場合
			768: {
        /*slidesPerGroup: 4,*/ //4枚ずつスライド
				/*slidesPerView: 1,*/
        speed: 3000,
			}
		}
	});
 
});



$(function () {
  $('.accordion-contents dt').click(function() {
    $(this).next('dd').slideToggle('fast'),
    $(this).toggleClass("open");
  });
});



/*↓複数用*/
function copyToClipboard(index) {
            // コピー対象をJavaScript上で変数として定義する
            var copyTarget = document.getElementById("copyTarget" + index);

            // コピー対象のテキストを選択する
            copyTarget.select();

            // 選択しているテキストをクリップボードにコピーする
            document.execCommand("Copy");

            // コピーをお知らせする
            alert("クーポンコードをコピーしました。 : " + copyTarget.value);
        }


  $(function() {
  $('.more-btn').on('click', function() {
    if( $(this).children().is('.open') ) {
      $(this).html('<p class="close">閉じる</p>').addClass('close-btn');
      $(this).parent().removeClass('slide-up').addClass('slide-down');
    } else {
      $(this).html('<p class="open">続きを読む</p>').removeClass('close-btn');
      $(this).parent().removeClass('slide-down').addClass('slide-up');
    }
  });
});